import Wrapper from './wrapper';
import {
  ITokenizedCreateParams,
  ITokenizedsListParams,
  ITokenizedUpdateParams,
  IWrapper,
} from './types';

class Tokenized {
  wrapper: IWrapper;
  /**
   * @param {Wrapper} wrapper
   */
  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }

  /**
   * Creates a new tokenized in your data pool
   * @param {Object} data
   * @returns {Promise}
   */
  create(data: ITokenizedCreateParams) {
    return this.wrapper.createTokenized(data);
  }

  /**
   * Gets a paginated list of tokenizeds that belong to your data pool
   * @param {[Object]} params - Search parameters
   * @returns {Promise}
   */
  list(params: ITokenizedsListParams) {
    return this.wrapper.listTokenizeds(params);
  }

  /**
   * Gets a single tokenized object that is updated
   * if it has not been updated within the refresh window
   * @param {string} id
   * @returns {Promise}
   */
  retrieveRefreshed(id: string) {
    return this.wrapper.retrieveRefreshedTokenized(id);
  }

  /**
   * Gets a single tokenized object
   * @param {string} id
   * @returns {Promise}
   */
  retrieve(id: string) {
    return this.wrapper.retrieveTokenized(id);
  }

  /**
   * Updates a tokenized
   * @param {string} id
   * @param {Object} data
   * @returns {Promise}
   */
  update(id: string, data: ITokenizedUpdateParams) {
    return this.wrapper.updateTokenized(id, data);
  }

  /**
   * Permanently removes a tokenized from your data pool.
   * @param {string} id
   * @returns {Promise}
   */
  del(id: string) {
    return this.wrapper.removeTokenized(id);
  }
}

export default Tokenized;
